'use strict';

const SELECTORS = {
    body: 'body',
    loadMoreSavedLooksBtn: '.js-load-more-looks',
    lookCard :'.c-look-card'
}

function init() {
    $(SELECTORS.body).on('click', SELECTORS.loadMoreSavedLooksBtn,  handleLoadMoreSavedLooks);
    initLazyLoad()
}

function initLazyLoad() {
    let $target = document.querySelector(SELECTORS.loadMoreSavedLooksBtn);
    if ($target) {
        let observer = new IntersectionObserver(handleIntersect, {
            threshold: 0.5
        });
        observer.observe($target);
    }
}

function handleIntersect(entries) {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            const $loadMoreButton = $(SELECTORS.loadMoreSavedLooksBtn);
            if ($loadMoreButton.length) {
                $loadMoreButton.trigger('click');
            }
        }
    });
}

/**
 * Handle load more saved looks.
 * @param {*} e
 */
const handleLoadMoreSavedLooks = (e) => {
    const $this = $(e.target);
    $this.parent().hide();

    let moreLooksUrl = $this.data('url');
    $.ajax({
        url: moreLooksUrl,
        type: 'GET',
        dataType: 'HTML',
        success: (response) => {
            $this.parent().remove();
            $(response).insertAfter($(SELECTORS.lookCard).last());
            initLazyLoad()
            $(SELECTORS.body).trigger('savedLooks:paginate');
        },
        error: () => {
            $this.parent().show();
        }
    });
}

module.exports = {
    init: init
}
